import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useRouteConfig } from './hooks/useRouteConfig';
import { Box, Typography } from '@mui/material';

export const DynamicRouter: React.FC = () => {
  const config = useRouteConfig();

  // If no config is available for the user's role
  if (!config) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <Typography variant="h6" color="error">
          No access configuration found for your role.
        </Typography>
      </Box>
    );
  }

  return (
    <Routes>
      <Route index element={<Navigate to="dashboard" replace />} />
      {config.routes.map((route, index) => (
        <Route key={`${route.path}-${index}`} path={route.path} element={route.element} />
      ))}
      {/* Catch-all route - redirect to dashboard within /app */}
      <Route path="*" element={<Navigate to="dashboard" replace />} />
    </Routes>
  );
};
